module.exports = __webpack_public_path__ + "assets/img/vhelp.e3cb8dac.png";